import React, { useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  Alert,
  Spinner
} from "react-bootstrap";
import style from "../Activity.module.css";
import { FaTrash, FaCalendarPlus } from "react-icons/fa6";
import Swal from 'sweetalert2';
import { addActivity } from "../../../utils/Data/Activities.js";

const AddActivity = ({ handleCloseModal }) => {
  const [activityName, setActivityName] = useState('');
  const [isSingleClass, setIsSingleClass] = useState(false);
  const [dates, setDates] = useState(['']);
  const [hour, setHour] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsSingleClass(e.target.checked);
    setDates(e.target.checked ? [''] : ['', '']);
  };

  const handleNameChange = (e) => setActivityName(e.target.value);

  const handleDateChange = (e, index) => {
    const newDates = [...dates];
    newDates[index] = e.target.value;
    setDates(newDates);
  };

  const handleHourChange = (e) => setHour(e.target.value);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!activityName || !hour || dates.some(date => !date)) {
      setError("Por favor, complete todos los campos.");
      return;
    }

    const fechasActividad = dates.map(fecha => ({ fecha, usuarios: [] }));

    try {
      setLoading(true);
      /* await addDoc(collection(db, "actividades"), {
        nombre: activityName,
        isSingleClass,
        fechas: fechasActividad,
        hora: hour
      }); */
      await addActivity(activityName, isSingleClass, fechasActividad, hour);
      Swal.fire({
        title: "Actividad agregada correctamente!",
        icon: "success",
      });
      handleCloseModal();
    } catch (e) {
      setLoading(false);
      console.error("Error adding document: ", e);
      setError("Hubo un error al agregar la actividad.");
    }
  };

  return (
    <Container className="py-2">
      <Form onSubmit={handleSubmit}>
        <Form.Group as={Row} controlId="activityName">
          <Form.Label className={style.formLabel}>Nombre de la actividad</Form.Label>
          <Col sm={10}>
            <Form.Control
              type="text"
              value={activityName}
              onChange={handleNameChange}
              required
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="hour" className="mt-3">
          <Form.Label className={style.formLabel}>Hora de la actividad:</Form.Label>
          <Col sm={10}>
            <Form.Control
              type="time"
              value={hour}
              onChange={handleHourChange}
              required
            />
          </Col>
        </Form.Group>

        <Form.Group as={Row} controlId="isSingleClass" className="mt-3">
          <Form.Label className={style.formLabel}>¿Es una clase única?</Form.Label>
          <Col sm={10}>
            <Form.Check
              type="switch"
              checked={isSingleClass}
              onChange={handleCheckboxChange}
            />
          </Col>
        </Form.Group>

        <h4 className={`${style.subtitle} mt-3`}>Fechas de la actividad:</h4>
        <Form.Group as={Row} controlId="dates" className="mt-3">
          <Col sm={10}>
            {dates.map((date, index) => (
              <Row key={index} className="mb-2">
                <Col sm={10}>
                  <Form.Control
                    type="date"
                    value={date}
                    onChange={(e) => handleDateChange(e, index)}
                    required
                  />
                </Col>
                <Col sm={2}>
                  {index > 0 && (
                    <Button
                      variant="danger"
                      type="button"
                      size="sm"
                      onClick={() => setDates(dates.filter((_, i) => i !== index))}
                    >
                      <FaTrash />
                    </Button>
                  )}
                </Col>
              </Row>
            ))}
            {!isSingleClass && (
              <Button
                variant="dark"
                type="button"
                onClick={() => setDates([...dates, ''])}
                className={`${style.addDateBtn} secondaryBtn d-flex align-items-center`}
              >
                <FaCalendarPlus /> Agregar Fecha
              </Button>
            )}
          </Col>
        </Form.Group>

        {error && <Alert variant="danger">{error}</Alert>}
        <Row>
          <Col className="d-flex justify-content-end">
            <Button variant="dark" className="secondaryBtn" onClick={handleCloseModal}>
              Cancelar
            </Button>
            <Button variant="dark" type="submit" className="mx-4 primaryBtn d-flex align-items-center">
              Agregar actividad {loading ? <Spinner animation="grow" size="sm" style={{marginLeft: "6px"}} /> : null}
            </Button>
          </Col>
        </Row>
      </Form>
    </Container>
  );
};

export default AddActivity;